// import debug
// import debug from 'bows';

class Header{
    constructor() {
        // set module name for debug
        // this.log = debug('header');
        // this.log('init');

        this.burger_btn = $('.header__burger');
        this.burget_opened = false;

        this.burger_btn.on('click', (e) => {
            // arrow function doesn't have its own `this`
            e.preventDefault();
            this.toggle();
        } );
    }

    open() {
        // this.log('burger open');
        // code open
        this.opened = true;
    }

    close() {
        // this.log('burger close');
        // code close
        this.opened = false;
    }

    toggle() {
        if (this.opened) {
            this.close();
        } else {
            this.open();
        }
    }
}

export default Header;